import React from "react";
import whychooseus from "../../Assets/Images/whyChooseUsImg.png";
import webeliveprofile1 from "../../Assets/Images/weBelieveProfile1.png";
import webeliveprofile2 from "../../Assets/Images/weBelieveProfile2.png";
import { RiDoubleQuotesL } from "react-icons/ri";
import { FaArrowRight } from "react-icons/fa6";
const WhyChooseUs = () => {
  return (
    <div className="container">
      <div className="row choose-us-section">
        <div className="col-lg-5 why-choose-us-content">
          <h3>Why Choose Us</h3>
          <p>
            “We’re not just an ISO certification provider — we’re your partner
            in building trust, credibility, and global recognition. With a
            passion for simplifying complex processes, our expert team turns
            certification into a smooth, efficient, and rewarding journey. From
            understanding your business needs to celebrating your certification
            success, we’re with you every step of the way. Our mission is simple
            — empower your business to meet global standards and stand out in
            your industry.”
          </p>
          <button className="why-choose-us-btn">
            See Team Behind Our Success < FaArrowRight/>
          </button>
        </div>
        <div className="col-lg-6 we-choose-img-Banner">
          <img className="why-choose-img" src={whychooseus} alt="" />
        </div>
      </div>

      <div className="">
        <div className="d-flex justify-content-between align-items-center believe-card-upper">
          <h3>We Believe people we trust</h3>
          <h6>See All < FaArrowRight/></h6>
        </div>
        <div className="we-beleive-cards">
          <div className="we-believe-card">
             <RiDoubleQuotesL style={{fontSize: "47px", color: "yellow" }}/>
            <p>
              We achieved ISO 27001 faster than expected thanks to their expert
              support. Highly recommended for any business looking to meet
              global standards.
            </p>
            <div className="d-flex gap-2 mt-4">
              <img className="profile-1" src={webeliveprofile1} alt="" />
              <h6>
                Andrew Wilkins <br />{" "}
                <span style={{ fontWeight: "400" }}>
                  Managing Director, Yess Company
                </span>
              </h6>
            </div>
          </div>

          <div className="we-believe-card">
            <RiDoubleQuotesL style={{fontSize: "47px", color: "yellow" }}/>
            <p>
              The team made our ISO 9001 certification process incredibly
              smooth. Their clear guidance and professional approach saved us
              both time and stress.
            </p>
            <div className="d-flex gap-2 mt-4">
              <img className="profile-2" src={webeliveprofile2} alt="" />
              <h6>
                Daisy Phelps <br />{" "}
                <span style={{ fontWeight: "400" }}>
                  Digital Marketing Director, Monatc
                </span>
              </h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;
